module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD7SURBVHgBzZIvD8IwEMVbJGCHngcNGs2wm55mEk8yjcPwFViCAz2PZho0WIYd7+CVNM3446DJL7fr3b2111Pq10u/ClRV1YHx6R601uevBFDYhYlA1wkVYOEKaac4gInBHmTgiIKSoiHoyT72Vqrmz32wBpE5CUhADDzuhczpm7oGAx7/nIs6/RR4vMpSBBGTU22ACDefAlgD2ow2YONmYMorDZ2csS0gai1woS/fV+uGbVBauaXxjcCWNqLN5eg45hzIVfyanJ360MQOG5jwFWqb6IqYhNQqavJFUsZGdk3dIMkETtTjze11nw00tXgr4Aj5dGWgTuov1w1jP6lh8V+nOAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/left-menu-10.png
// module id = 2662
// module chunks = 0